/*
* @Author: zhengxiaowen
* @Date: 2018-08-21 11:46:27
* @Last Modified by: zhengxiaowen
* @Last Modified time: 2019-04-24 16:14:26
*/


import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'

import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import { sync } from 'vuex-router-sync'
import './assets/iconfont/iconfont.css'
import './assets/style/style.less'
import VueBetterScroll from 'vue2-better-scroll'
import moment from 'moment'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import lodash from 'lodash'


import routes from './common/config/routerCommon'
import store from './common/store/StoreCommon'
import nativeApi from './common/tool/sdk2/nativeApi'

import 'vant/lib/index.css'
import './vant'
import '@vant/touch-emulator';






window._ = lodash
window.moment = moment
window['GoogleAnalyticsObject'] = 'ga'

Vue.use(VueRouter)
Vue.use(VueBetterScroll)

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)


Vue.use(Vuex)
Vue.use(DatetimePlugin)
const router = new VueRouter({
routes
})

sync(store, router)
FastClick.attach(document.body)

Vue.config.productionTip = false

const history = window.sessionStorage
let isNative = history.isNative
history.clear()
history.isNative = isNative 
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)
let isPush = false
let endTime = Date.now()
let methods = ['push', 'go', 'replace', 'forward', 'back']

document.addEventListener('touchend', () => {
endTime = Date.now()
})

methods.forEach(key => {
let method = router[key].bind(router)
router[key] = function (...args) {
isPush = true
method.apply(null, args)
}
})
router.beforeEach(function (to, from, next) {
if (to.meta.keepAlive !== false) {
to.meta.keepAlive = true
}

const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)

if (to.fullPath != "/srmLogin/") {
console.log('/srmLogin/');
if (!store.state.user.userInfo) {
if (from.fullPath != "/srmLogin/") {
next("/srmLogin/")
}
return
}
}

store.commit('updateLoadingStatus', { isLoading: true })
console.log(toIndex);

let obj = _.find(routes, function (item) { return item.name == to.name })

store.commit('SET_ROUTER', obj)

if (store.state.system.isNative) {
if (to.path == '/' && from.path != '/') {
nativeApi.nativeFN.RNGoBack()
}

}


if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
store.commit('updateDirection', { direction: 'forward' })
} else {

if (!isPush && (Date.now() - endTime) < 377) {
store.commit('updateDirection', { direction: '' })
} else {
store.commit('updateDirection', { direction: 'reverse' })
}
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit('updateDirection', { direction: 'forward' })
}

if (/\/http/.test(to.path)) {
let url = to.path.split('http')[1]
window.location.href = `http${url}`
} else {
next()
}
})

router.afterEach(function (to) {
isPush = false
store.commit('updateLoadingStatus', { isLoading: false })




})

/* eslint-disable no-new */
new Vue({
store,
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js